import { User } from '@types'

const toNumber = (value?: number) => Number(value) || 0

export const processCommission = (user: User) => {
  const commission = {
    amount: user.commission?.amount,
    percentage: user.commission?.percentage,
    promotionAmount: user.commission?.promotionAmount,
    promotionPercentage: user.commission?.promotionPercentage
  }

  const prepayment =
    user.commission?.amount !== undefined || user.commission?.percentage !== undefined
      ? toNumber(user.prepayment?.amount)
      : 0

  const total = toNumber(commission.amount) + toNumber(commission.promotionAmount) - prepayment

  return {
    commission,
    prepayment,
    total
  }
}
